module.exports = __webpack_public_path__ + "img/cloud (1).97096a06.png";